/* eslint-disable react/forbid-prop-types */
import React from 'react';
import PropTypes from 'prop-types';

import StepProgressBar from '../../../../components/stepProgressBar';
import ContentSection from '../../../../components/contentSection';
import Typography from '../../../../components/typography';
import Button from '../../../../components/button';

import { useValidationCountry, useFetchIpData } from '../../../../utils/validationCountry';

import './stepExcelErrors.scss';

const StepExcelErrors = ({
  setSection, excelErrors, isMobileDevice, currentStep, step,
}) => {
  const ipData = useFetchIpData();
  const isCountryValid = useValidationCountry(ipData.country);
  return (
    <ContentSection>
      <div id="multiple-shippings__excel-errors">
        <div className="progressBar">
          <StepProgressBar
            steps={[{}, {}, {}, {}].map((item, index) => {
              const newItem = item;
              if (index < step) newItem.success = true;
              return newItem;
            })}
            currentStep={currentStep}
          />
        </div>
        <div className={`content-bottom ${isMobileDevice ? '' : 'full-height'}`}>
          <div className="container-list__excel-errors">
            {excelErrors && (
            <>
              <hr />
              <div className="item header">
                <div>
                  <Typography
                    type="field"
                    text="Fila"
                    className="field dark font-size-14"
                  />
                </div>
                <div>
                  <Typography
                    type="field"
                    text="Error"
                    className="field dark font-size-14"
                  />
                </div>
              </div>
              {excelErrors.map((error) => (
                <div className="item" key={error.row}>
                  <div>
                    <Typography
                      type="field"
                      text={error.row + 1}
                      className="field dark font-size-14"
                    />
                  </div>
                  <div>
                    <Typography
                      type="value"
                      text={error.errors.join(' - ')}
                    />
                  </div>
                </div>
              ))}
            </>
            )}

          </div>
          <div className="container-buttons__content-bottom">
            <div />
            <Button
              text="Cotizar nuevamente"
              type={isCountryValid ? 'primary-mx' : 'quaternary'}
              onClick={() => setSection()}
            />
          </div>
        </div>
      </div>
    </ContentSection>
  );
};

StepExcelErrors.propTypes = {
  setSection: PropTypes.func.isRequired,
  excelErrors: PropTypes.any.isRequired,
  isMobileDevice: PropTypes.bool.isRequired,
  currentStep: PropTypes.number.isRequired,
  step: PropTypes.number.isRequired,
};

export default StepExcelErrors;
